import React, { useMemo } from 'react';
import { useDashboardFeatureFlags } from '@components';
import { Suggestion } from '@components/common/Suggestion';
import { useWebViewBridge } from '@fourthwall/webview-bridge';
import { useOnboarding } from '@modules/Dashboard/Home/hooks/useOnboarding';
import { useOnboardingSummaryQuery } from '@modules/Dashboard/Home/queries/useOnboardingSummaryQuery';
import { CreateProductRecommendationContent } from '@modules/Dashboard/modules/Recommendations/modules/CreateProductRecommendation/components/CreateProductRecommendationContent';
import { routing } from '@utils/routing';
import { Award } from '../../../components/Award/Award';
import { useCampaignStatus } from '../../../hooks/useCampaignStatus';
import { useRecommendationsDismiss } from '../../../hooks/useRecommendationsDismiss';
import { getRecommendationBadge } from '../../../utils/getRecommendationBadge';
import createANewProduct from '../assets/create-a-new-product.png';
export const useCreateProductRecommendation = () => {
    const { dashboardFeatureFlags } = useDashboardFeatureFlags();
    const { onboardingSummaryQuery } = useOnboardingSummaryQuery(undefined, {
        enabled: dashboardFeatureFlags.homeProducts.enabled,
    });
    const { onboarding } = useOnboarding();
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    const { methods, isWebView } = useWebViewBridge();
    const { activeIncentives } = useCampaignStatus();
    const incentive = activeIncentives.find((i) => i.recommendationId === 'createProduct');
    const enabled = useMemo(() => {
        if (dashboardFeatureFlags.homeProducts.enabled) {
            return false;
        }
        const createProductItem = onboarding.onboardingProps?.onboardingListProps.items.find(({ key }) => key === 'CreateNewProduct');
        if (['ONBOARDING_SHOP', 'ONBOARDING_SHOP_MEMBERSHIPS'].includes(onboarding.onboardingType) &&
            !createProductItem?.completed) {
            return false;
        }
        return recommendationsDismiss.createProduct.visible;
    }, [
        dashboardFeatureFlags.homeProducts.enabled,
        onboarding.onboardingProps?.onboardingListProps.items,
        onboarding.onboardingType,
        recommendationsDismiss.createProduct.visible,
    ]);
    return {
        createProductRecommendation: {
            id: 'createProduct',
            enabled,
            isLoading: onboardingSummaryQuery.isInitialLoading,
            suggestion: isWebView ? (React.createElement(Suggestion, { title: "Create a new product", description: "Design a new product or list something you own", analytics: "createANewProduct", badge: getRecommendationBadge(onboardingSummaryQuery.data?.recommendations.find((item) => item.action.type === 'CreateNewProduct')), buttonLabel: "Create a new product", imageUrl: createANewProduct, onButtonClick: async () => {
                    await methods.openMobilePage?.({
                        mobile_path: 'product_catalog',
                        url: routing.productCatalog.self,
                    });
                } })) : (React.createElement(Suggestion, { title: "Create a new product", description: "Design a new product or list something you own", analytics: "createANewProduct", award: incentive ? (React.createElement(Award, { value: incentive.incentive.bonus.value, currency: "USD", text: "sample credit" })) : undefined, content: React.createElement(CreateProductRecommendationContent, null), imageUrl: createANewProduct, onDismiss: createOnDismiss(recommendationsDismiss.createProduct.dismiss) })),
        },
    };
};
